module.exports = __webpack_public_path__ + "static/img/movilidad-sostenible.cb6f0733.png";